<div class="expand-tile-table">
  <table mat-table [dataSource]="dataSource" matSort>
    <ng-container
      *ngFor="let column of displayedColumns; let i = index"
      [matColumnDef]="column"
      [sticky]="i == 0"
    >
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ column }}
        <custom-mat-table-sort-icon
          [activeColumn]="sort.active"
          [column]="column"
          [sortDirection]="sort.direction"
        ></custom-mat-table-sort-icon>
      </th>
      <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
